module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg3.59b266f8.png";